module.exports = __webpack_public_path__ + "static/media/woman-working-on-laptop.39d978f4.jpg";